var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.216 46.9951L38.9899 13.0171L33.0049 22.1415L15.7521 2.78612C15.7521 2.78612 14.466 8.12361 11.2516 12.7278C8.03714 17.332 2.67915 20.6159 2.67915 20.6159L24.163 35.0126L15.2089 42.5025L48.216 46.9951Z",
    stroke: "#1B3B5F",
    strokeWidth: 2.20196
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f689c68576392bb6bce5ea05bd26ab76.svg";
export { ForwardRef as ReactComponent };